const LABEL_TO_ISO = {
  anglais: 'en',
  français: 'fr',
  francais: 'fr',
  allemand: 'de',
  espagnol: 'es',
  italien: 'it',
  bulgare: 'bg',
  coréen: 'ko',
  coreen: 'ko',
  estonien: 'et',
  finnois: 'fi',
  grec: 'el',
  néerlandais: 'nl',
  neerlandais: 'nl',
  polish: 'pl',
  polonais: 'pl',
  portugais: 'pt',
  roumain: 'ro',
  russe: 'ru',
  czech: 'cs',
  slovaque: 'sk',
};

export const getScoringLanguageLabel = (languageSource) => {
  if (!languageSource) return 'Français';
  if (typeof languageSource === 'string') {
    const trimmed = languageSource.trim();
    return trimmed || 'Français';
  }
  return (
    languageSource.language?.trim() ||
    languageSource.name?.trim() ||
    languageSource.abbreviation?.trim() ||
    languageSource.isoCode?.trim() ||
    languageSource.code?.trim() ||
    'Français'
  );
};

export const getLanguageIsoCode = (languageSource) => {
  if (!languageSource) return 'fr';

  if (typeof languageSource === 'object') {
    const code = String(
      languageSource.abbreviation ||
        languageSource.isoCode ||
        languageSource.code ||
        ''
    )
      .trim()
      .toLowerCase();
    if (code.length === 2) return code;
  }

  if (typeof languageSource === 'string') {
    const trimmed = languageSource.trim().toLowerCase();
    if (LABEL_TO_ISO[trimmed]) return LABEL_TO_ISO[trimmed];
    if (trimmed.length === 2) return trimmed;
  }

  const label = getScoringLanguageLabel(languageSource).toLowerCase();
  if (LABEL_TO_ISO[label]) return LABEL_TO_ISO[label];
  if (label.length === 2) return label;
  return 'fr';
};


export const getCountryIsoCode = (countryOrWebsite) => {
  if (!countryOrWebsite) return 'FR';
  if (typeof countryOrWebsite === 'string') {
    return countryOrWebsite.trim().toUpperCase().slice(0, 2) || 'FR';
  }
  const code =
    countryOrWebsite.country ||
    countryOrWebsite.code ||
    countryOrWebsite.isoCode ||
    countryOrWebsite.countryCode ||
    '';
  return String(code).trim().toUpperCase().slice(0, 2) || 'FR';
};
